import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=99f493a2&scoped=true"
import script from "./message-list.vue?vue&type=script&lang=js"
export * from "./message-list.vue?vue&type=script&lang=js"
import style0 from "./message-list.vue?vue&type=style&index=0&id=99f493a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f493a2",
  null
  
)

export default component.exports